<style lang="sass" rel="stylesheet/sass">
    @import visual
    @import lazyload
</style>

<template>
    <icon v-if="svg" :src="svg" class="g_visual" />
    <i v-else-if="fontIcon" :class="fontIcon" />
    <img v-else class="g_visual" v-img-src="src" />
</template>
<script>
import Vue from 'vue'

export default {
    name: 'Visual',
    props: {
        src: Object,
        svg: String,
        fontIcon: String
    },
    created () {
        if (this.svg) {
            Vue.component('icon', () => import(/* webpackChunkName: "Icon" */ 'components/icon/Icon').then(m => m.default))
        }
    }
}
</script>
